export class SubscriptionProduct {
  id: number;
  priceID: string;
  name: string;
  price: number;
  length: number;
  jobs: number;
  candidates: number;
  url?: string;
  features: string[];
  partner?: string;

  constructor(plan) {
    this.id = plan.Subid;
    this.priceID = plan.priceid;
    this.name = plan.SubscriptionName;
    this.price = plan.price;
    this.length = plan.sublength;
    this.jobs = plan.jobs;
    this.candidates = plan.candidates;
    this.features = plan.featuresJSON.features;
    this.url = plan.url;
    this.partner = plan.subtype;
  }
}
